import type { CallToolResult } from '@modelcontextprotocol/sdk/types.js';
import type { IFIXParser, Message } from 'fixparser';

export const createParseHandler = (parser: IFIXParser): ((args: { fixString: string }) => Promise<CallToolResult>) => {
    return async (args: { fixString: string }): Promise<CallToolResult> => {
        try {
            const parsedMessage: Message[] | undefined = parser.parse(args.fixString);
            if (!parsedMessage || parsedMessage.length === 0) {
                return {
                    content: [
                        {
                            type: 'text',
                            text: 'Error: Failed to parse FIX string',
                            uri: 'parse',
                        },
                    ],
                    isError: true,
                };
            }

            return {
                content: [
                    {
                        type: 'text',
                        text: `${parsedMessage[0].description}\n${parsedMessage[0].messageTypeDescription}`,
                        uri: 'parse',
                    },
                ],
            };
        } catch (error) {
            return {
                content: [
                    {
                        type: 'text',
                        text: `Error: ${error instanceof Error ? error.message : 'Failed to parse FIX string'}`,
                        uri: 'parse',
                    },
                ],
                isError: true,
            };
        }
    };
};
